@file:OptIn(InternalResourceApi::class)

package com.karyadina.common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.karyadina.common.generated.resources/"

@delegate:ResourceContentHash(1_776_221_007)
internal val Res.string.notes_action_translate: StringResource by lazy {
      StringResource("string:notes_action_translate", "notes_action_translate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11224, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5896, 54),
      ))
    }

@delegate:ResourceContentHash(-1_928_130_189)
internal val Res.string.notes_action_undo: StringResource by lazy {
      StringResource("string:notes_action_undo", "notes_action_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11331, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5951, 33),
      ))
    }

@delegate:ResourceContentHash(2_049_255_725)
internal val Res.string.notes_archive: StringResource by lazy {
      StringResource("string:notes_archive", "notes_archive", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11405, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5985, 33),
      ))
    }

@delegate:ResourceContentHash(703_088_466)
internal val Res.string.notes_chk_all_completed: StringResource by lazy {
      StringResource("string:notes_chk_all_completed", "notes_chk_all_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11553, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6093, 59),
      ))
    }

@delegate:ResourceContentHash(701_225_785)
internal val Res.string.notes_chk_all_completed_emoji: StringResource by lazy {
      StringResource("string:notes_chk_all_completed_emoji", "notes_chk_all_completed_emoji", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11451, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6019, 73),
      ))
    }

@delegate:ResourceContentHash(528_211_405)
internal val Res.string.notes_chk_progress_format: StringResource by lazy {
      StringResource("string:notes_chk_progress_format", "notes_chk_progress_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11641, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6153, 57),
      ))
    }

@delegate:ResourceContentHash(-78_606_955)
internal val Res.string.notes_chk_tasks_remaining_format: StringResource by lazy {
      StringResource("string:notes_chk_tasks_remaining_format", "notes_chk_tasks_remaining_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11711, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6211, 68),
      ))
    }

@delegate:ResourceContentHash(-251_547_496)
internal val Res.string.notes_chk_view_all_format: StringResource by lazy {
      StringResource("string:notes_chk_view_all_format", "notes_chk_view_all_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11792, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6280, 61),
      ))
    }

@delegate:ResourceContentHash(64_849_702)
internal val Res.string.notes_details_title: StringResource by lazy {
      StringResource("string:notes_details_title", "notes_details_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11886, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6342, 43),
      ))
    }

@delegate:ResourceContentHash(357_963_696)
internal val Res.string.notes_filter_all: StringResource by lazy {
      StringResource("string:notes_filter_all", "notes_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11950, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6386, 28),
      ))
    }

@delegate:ResourceContentHash(997_801_426)
internal val Res.string.notes_filter_archived: StringResource by lazy {
      StringResource("string:notes_filter_archived", "notes_filter_archived", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 11987, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6415, 41),
      ))
    }

@delegate:ResourceContentHash(-1_394_357_271)
internal val Res.string.notes_filter_pinned: StringResource by lazy {
      StringResource("string:notes_filter_pinned", "notes_filter_pinned", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12057, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6457, 35),
      ))
    }

@delegate:ResourceContentHash(-1_271_532_630)
internal val Res.string.notes_img_fullscreen_desc: StringResource by lazy {
      StringResource("string:notes_img_fullscreen_desc", "notes_img_fullscreen_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12121, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6493, 57),
      ))
    }

@delegate:ResourceContentHash(-205_409_639)
internal val Res.string.notes_label_attachments: StringResource by lazy {
      StringResource("string:notes_label_attachments", "notes_label_attachments", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12219, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6551, 47),
      ))
    }

@delegate:ResourceContentHash(1_693_459_486)
internal val Res.string.notes_label_tags: StringResource by lazy {
      StringResource("string:notes_label_tags", "notes_label_tags", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12279, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6599, 32),
      ))
    }

@delegate:ResourceContentHash(-19_976_328)
internal val Res.string.notes_msg_create_first: StringResource by lazy {
      StringResource("string:notes_msg_create_first", "notes_msg_create_first", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12316, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6632, 74),
      ))
    }

@delegate:ResourceContentHash(246_699_126)
internal val Res.string.notes_msg_deleted: StringResource by lazy {
      StringResource("string:notes_msg_deleted", "notes_msg_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12471, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6707, 41),
      ))
    }

@delegate:ResourceContentHash(-324_147_606)
internal val Res.string.notes_msg_no_notes: StringResource by lazy {
      StringResource("string:notes_msg_no_notes", "notes_msg_no_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12545, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6749, 42),
      ))
    }

@delegate:ResourceContentHash(127_963_674)
internal val Res.string.notes_new_note: StringResource by lazy {
      StringResource("string:notes_new_note", "notes_new_note", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12640, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6792, 34),
      ))
    }

@delegate:ResourceContentHash(-719_768_640)
internal val Res.string.notes_pin: StringResource by lazy {
      StringResource("string:notes_pin", "notes_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12691, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6827, 21),
      ))
    }

@delegate:ResourceContentHash(1_096_399_550)
internal val Res.string.notes_progress_label: StringResource by lazy {
      StringResource("string:notes_progress_label", "notes_progress_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12721, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6849, 40),
      ))
    }

@delegate:ResourceContentHash(185_425_010)
internal val Res.string.notes_search_placeholder: StringResource by lazy {
      StringResource("string:notes_search_placeholder", "notes_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12774, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6890, 52),
      ))
    }

@delegate:ResourceContentHash(1_415_370_555)
internal val Res.string.notes_stat_tasks: StringResource by lazy {
      StringResource("string:notes_stat_tasks", "notes_stat_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12855, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6943, 32),
      ))
    }

@delegate:ResourceContentHash(853_632_421)
internal val Res.string.notes_title: StringResource by lazy {
      StringResource("string:notes_title", "notes_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12900, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6976, 35),
      ))
    }

@delegate:ResourceContentHash(1_534_259_425)
internal val Res.string.notes_unarchive: StringResource by lazy {
      StringResource("string:notes_unarchive", "notes_unarchive", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 12968, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7012, 35),
      ))
    }

@delegate:ResourceContentHash(2_032_665_290)
internal val Res.string.notes_unpin: StringResource by lazy {
      StringResource("string:notes_unpin", "notes_unpin", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13020, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7048, 27),
      ))
    }

@delegate:ResourceContentHash(326_052_279)
internal val Res.string.notes_view_full: StringResource by lazy {
      StringResource("string:notes_view_full", "notes_view_full", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13060, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7076, 51),
      ))
    }

@delegate:ResourceContentHash(-1_747_721_530)
internal val Res.string.onboarding_continue: StringResource by lazy {
      StringResource("string:onboarding_continue", "onboarding_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13188, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7128, 51),
      ))
    }

@delegate:ResourceContentHash(1_460_494_604)
internal val Res.string.onboarding_subtitle: StringResource by lazy {
      StringResource("string:onboarding_subtitle", "onboarding_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13276, 379),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7180, 127),
      ))
    }

@delegate:ResourceContentHash(-727_588_684)
internal val Res.string.onboarding_title: StringResource by lazy {
      StringResource("string:onboarding_title", "onboarding_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13656, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7308, 48),
      ))
    }

@delegate:ResourceContentHash(1_646_754_428)
internal val Res.string.pdf_arrange_desc: StringResource by lazy {
      StringResource("string:pdf_arrange_desc", "pdf_arrange_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13741, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7357, 56),
      ))
    }

@delegate:ResourceContentHash(-1_745_763_582)
internal val Res.string.pdf_arrange_dialog_title: StringResource by lazy {
      StringResource("string:pdf_arrange_dialog_title", "pdf_arrange_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 13898, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7414, 52),
      ))
    }

@delegate:ResourceContentHash(1_047_019_275)
internal val Res.string.pdf_arrange_pages_format: StringResource by lazy {
      StringResource("string:pdf_arrange_pages_format", "pdf_arrange_pages_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14011, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7467, 48),
      ))
    }

@delegate:ResourceContentHash(995_387_591)
internal val Res.string.pdf_arrange_title: StringResource by lazy {
      StringResource("string:pdf_arrange_title", "pdf_arrange_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14072, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7516, 57),
      ))
    }

@delegate:ResourceContentHash(660_994_207)
internal val Res.string.pdf_btn_change_images: StringResource by lazy {
      StringResource("string:pdf_btn_change_images", "pdf_btn_change_images", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14226, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7574, 57),
      ))
    }

@delegate:ResourceContentHash(754_044_296)
internal val Res.string.pdf_btn_choose_images: StringResource by lazy {
      StringResource("string:pdf_btn_choose_images", "pdf_btn_choose_images", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14312, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7632, 49),
      ))
    }

@delegate:ResourceContentHash(-1_566_473_033)
internal val Res.string.pdf_btn_create: StringResource by lazy {
      StringResource("string:pdf_btn_create", "pdf_btn_create", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14485, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7737, 50),
      ))
    }

@delegate:ResourceContentHash(-26_466_649)
internal val Res.string.pdf_btn_create_another: StringResource by lazy {
      StringResource("string:pdf_btn_create_another", "pdf_btn_create_another", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14390, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7682, 54),
      ))
    }

@delegate:ResourceContentHash(-219_137_850)
internal val Res.string.pdf_btn_edit_settings: StringResource by lazy {
      StringResource("string:pdf_btn_edit_settings", "pdf_btn_edit_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14592, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7788, 65),
      ))
    }

@delegate:ResourceContentHash(1_099_644_034)
internal val Res.string.pdf_error_generic: StringResource by lazy {
      StringResource("string:pdf_error_generic", "pdf_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14746, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7854, 53),
      ))
    }

@delegate:ResourceContentHash(194_198_224)
internal val Res.string.pdf_error_open: StringResource by lazy {
      StringResource("string:pdf_error_open", "pdf_error_open", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14848, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7908, 46),
      ))
    }

@delegate:ResourceContentHash(917_380_868)
internal val Res.string.pdf_error_prefix: StringResource by lazy {
      StringResource("string:pdf_error_prefix", "pdf_error_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 14947, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7955, 32),
      ))
    }

@delegate:ResourceContentHash(-774_465_306)
internal val Res.string.pdf_error_select: StringResource by lazy {
      StringResource("string:pdf_error_select", "pdf_error_select", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15000, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7988, 56),
      ))
    }

@delegate:ResourceContentHash(-526_770_768)
internal val Res.string.pdf_error_share: StringResource by lazy {
      StringResource("string:pdf_error_share", "pdf_error_share", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15101, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8045, 51),
      ))
    }

@delegate:ResourceContentHash(-2_043_754_968)
internal val Res.string.pdf_label_max_size: StringResource by lazy {
      StringResource("string:pdf_label_max_size", "pdf_label_max_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15217, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8097, 54),
      ))
    }

@delegate:ResourceContentHash(565_906_614)
internal val Res.string.pdf_label_page_size: StringResource by lazy {
      StringResource("string:pdf_label_page_size", "pdf_label_page_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15324, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8152, 39),
      ))
    }

@delegate:ResourceContentHash(-413_010_322)
internal val Res.string.pdf_label_quality: StringResource by lazy {
      StringResource("string:pdf_label_quality", "pdf_label_quality", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15392, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8192, 37),
      ))
    }

@delegate:ResourceContentHash(2_063_361_025)
internal val Res.string.pdf_placeholder_max_size: StringResource by lazy {
      StringResource("string:pdf_placeholder_max_size", "pdf_placeholder_max_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15450, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8230, 48),
      ))
    }

@delegate:ResourceContentHash(629_995_090)
internal val Res.string.pdf_size_good: StringResource by lazy {
      StringResource("string:pdf_size_good", "pdf_size_good", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15511, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8279, 29),
      ))
    }

@delegate:ResourceContentHash(1_763_627_999)
internal val Res.string.pdf_size_heavy: StringResource by lazy {
      StringResource("string:pdf_size_heavy", "pdf_size_heavy", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15553, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8309, 30),
      ))
    }

@delegate:ResourceContentHash(-1_631_756_104)
internal val Res.string.pdf_size_large: StringResource by lazy {
      StringResource("string:pdf_size_large", "pdf_size_large", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15592, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8340, 30),
      ))
    }

@delegate:ResourceContentHash(2_091_361_857)
internal val Res.string.pdf_size_medium: StringResource by lazy {
      StringResource("string:pdf_size_medium", "pdf_size_medium", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15631, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8371, 31),
      ))
    }

@delegate:ResourceContentHash(201_302_838)
internal val Res.string.pdf_size_optimal: StringResource by lazy {
      StringResource("string:pdf_size_optimal", "pdf_size_optimal", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15675, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8403, 36),
      ))
    }

@delegate:ResourceContentHash(-1_259_498_627)
internal val Res.string.pdf_stat_file_size: StringResource by lazy {
      StringResource("string:pdf_stat_file_size", "pdf_stat_file_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15724, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8440, 38),
      ))
    }

@delegate:ResourceContentHash(-1_667_858_982)
internal val Res.string.pdf_stat_images: StringResource by lazy {
      StringResource("string:pdf_stat_images", "pdf_stat_images", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15791, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8479, 31),
      ))
    }

@delegate:ResourceContentHash(969_347_423)
internal val Res.string.pdf_stat_pages: StringResource by lazy {
      StringResource("string:pdf_stat_pages", "pdf_stat_pages", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15839, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8511, 30),
      ))
    }

@delegate:ResourceContentHash(1_757_403_522)
internal val Res.string.pdf_stat_total_size: StringResource by lazy {
      StringResource("string:pdf_stat_total_size", "pdf_stat_total_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15882, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8542, 43),
      ))
    }

@delegate:ResourceContentHash(1_042_237_433)
internal val Res.string.pdf_status_converting: StringResource by lazy {
      StringResource("string:pdf_status_converting", "pdf_status_converting", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 15942, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8586, 49),
      ))
    }

@delegate:ResourceContentHash(127_125_875)
internal val Res.string.pdf_step1_subtitle: StringResource by lazy {
      StringResource("string:pdf_step1_subtitle", "pdf_step1_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16012, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8636, 58),
      ))
    }

@delegate:ResourceContentHash(-1_227_873_597)
internal val Res.string.pdf_step1_title: StringResource by lazy {
      StringResource("string:pdf_step1_title", "pdf_step1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16131, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8695, 43),
      ))
    }

@delegate:ResourceContentHash(1_762_185_032)
internal val Res.string.pdf_step2_subtitle: StringResource by lazy {
      StringResource("string:pdf_step2_subtitle", "pdf_step2_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16203, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8739, 54),
      ))
    }

@delegate:ResourceContentHash(1_449_721_387)
internal val Res.string.pdf_step2_title: StringResource by lazy {
      StringResource("string:pdf_step2_title", "pdf_step2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16334, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8794, 39),
      ))
    }

@delegate:ResourceContentHash(117_843_769)
internal val Res.string.pdf_step3_subtitle: StringResource by lazy {
      StringResource("string:pdf_step3_subtitle", "pdf_step3_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16418, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8834, 62),
      ))
    }

@delegate:ResourceContentHash(681_880_102)
internal val Res.string.pdf_step3_title: StringResource by lazy {
      StringResource("string:pdf_step3_title", "pdf_step3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16545, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8897, 43),
      ))
    }

@delegate:ResourceContentHash(-263_660_039)
internal val Res.string.pdf_step4_subtitle: StringResource by lazy {
      StringResource("string:pdf_step4_subtitle", "pdf_step4_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16629, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8941, 58),
      ))
    }

@delegate:ResourceContentHash(799_463_772)
internal val Res.string.pdf_step4_title: StringResource by lazy {
      StringResource("string:pdf_step4_title", "pdf_step4_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16760, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9000, 31),
      ))
    }

@delegate:ResourceContentHash(-929_820_039)
internal val Res.string.pdf_success_message: StringResource by lazy {
      StringResource("string:pdf_success_message", "pdf_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16808, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9032, 63),
      ))
    }

@delegate:ResourceContentHash(-64_735_349)
internal val Res.string.pdf_tool_subtitle: StringResource by lazy {
      StringResource("string:pdf_tool_subtitle", "pdf_tool_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 16944, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9096, 65),
      ))
    }

@delegate:ResourceContentHash(1_394_129)
internal val Res.string.pdf_tool_title: StringResource by lazy {
      StringResource("string:pdf_tool_title", "pdf_tool_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17074, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9162, 38),
      ))
    }

@delegate:ResourceContentHash(233_371_688)
internal val Res.string.persona_creator_desc: StringResource by lazy {
      StringResource("string:persona_creator_desc", "persona_creator_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17145, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9201, 72),
      ))
    }

@delegate:ResourceContentHash(-1_984_357_589)
internal val Res.string.persona_creator_name: StringResource by lazy {
      StringResource("string:persona_creator_name", "persona_creator_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17278, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9274, 48),
      ))
    }

@delegate:ResourceContentHash(-64_913_423)
internal val Res.string.persona_developer_desc: StringResource by lazy {
      StringResource("string:persona_developer_desc", "persona_developer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17363, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9323, 62),
      ))
    }

@delegate:ResourceContentHash(1_727_018_441)
internal val Res.string.persona_developer_name: StringResource by lazy {
      StringResource("string:persona_developer_name", "persona_developer_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17482, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9386, 50),
      ))
    }

@delegate:ResourceContentHash(1_134_387_837)
internal val Res.string.persona_general_desc: StringResource by lazy {
      StringResource("string:persona_general_desc", "persona_general_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17557, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9437, 52),
      ))
    }

@delegate:ResourceContentHash(1_134_149_488)
internal val Res.string.persona_general_name: StringResource by lazy {
      StringResource("string:persona_general_name", "persona_general_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17630, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9490, 40),
      ))
    }

@delegate:ResourceContentHash(-510_399_471)
internal val Res.string.persona_professional_desc: StringResource by lazy {
      StringResource("string:persona_professional_desc", "persona_professional_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17687, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9531, 73),
      ))
    }

@delegate:ResourceContentHash(-210_821_028)
internal val Res.string.persona_professional_name: StringResource by lazy {
      StringResource("string:persona_professional_name", "persona_professional_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17825, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9605, 49),
      ))
    }

@delegate:ResourceContentHash(343_677_631)
internal val Res.string.persona_researcher_desc: StringResource by lazy {
      StringResource("string:persona_researcher_desc", "persona_researcher_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 17883, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9655, 75),
      ))
    }

@delegate:ResourceContentHash(-791_579_464)
internal val Res.string.persona_researcher_name: StringResource by lazy {
      StringResource("string:persona_researcher_name", "persona_researcher_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18023, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9731, 47),
      ))
    }

@delegate:ResourceContentHash(-1_133_125_244)
internal val Res.string.persona_student_desc: StringResource by lazy {
      StringResource("string:persona_student_desc", "persona_student_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18087, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9779, 76),
      ))
    }

@delegate:ResourceContentHash(-1_434_813_671)
internal val Res.string.persona_student_name: StringResource by lazy {
      StringResource("string:persona_student_name", "persona_student_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18240, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9856, 40),
      ))
    }

@delegate:ResourceContentHash(1_446_178_525)
internal val Res.string.planner_badge_completed: StringResource by lazy {
      StringResource("string:planner_badge_completed", "planner_badge_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18289, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9897, 43),
      ))
    }

@delegate:ResourceContentHash(1_383_085_788)
internal val Res.string.planner_badge_left: StringResource by lazy {
      StringResource("string:planner_badge_left", "planner_badge_left", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18341, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9941, 46),
      ))
    }

@delegate:ResourceContentHash(558_741_872)
internal val Res.string.planner_card_notes: StringResource by lazy {
      StringResource("string:planner_card_notes", "planner_card_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18404, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9988, 34),
      ))
    }

@delegate:ResourceContentHash(-1_097_120_905)
internal val Res.string.planner_card_remaining: StringResource by lazy {
      StringResource("string:planner_card_remaining", "planner_card_remaining", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18455, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10023, 42),
      ))
    }

@delegate:ResourceContentHash(-213_004_060)
internal val Res.string.planner_card_spent: StringResource by lazy {
      StringResource("string:planner_card_spent", "planner_card_spent", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18498, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10066, 34),
      ))
    }

@delegate:ResourceContentHash(186_130_610)
internal val Res.string.planner_card_target: StringResource by lazy {
      StringResource("string:planner_card_target", "planner_card_target", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18549, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10101, 35),
      ))
    }

@delegate:ResourceContentHash(940_923_400)
internal val Res.string.planner_dialog_add_session_title: StringResource by lazy {
      StringResource("string:planner_dialog_add_session_title", "planner_dialog_add_session_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18601, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10137, 64),
      ))
    }

@delegate:ResourceContentHash(349_853_864)
internal val Res.string.planner_dialog_add_subject_title: StringResource by lazy {
      StringResource("string:planner_dialog_add_subject_title", "planner_dialog_add_subject_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18698, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10202, 56),
      ))
    }

@delegate:ResourceContentHash(-791_168_839)
internal val Res.string.planner_dialog_delete_msg: StringResource by lazy {
      StringResource("string:planner_dialog_delete_msg", "planner_dialog_delete_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18771, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10259, 93),
      ))
    }

@delegate:ResourceContentHash(-1_756_013_851)
internal val Res.string.planner_dialog_delete_title: StringResource by lazy {
      StringResource("string:planner_dialog_delete_title", "planner_dialog_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 18941, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10353, 55),
      ))
    }

@delegate:ResourceContentHash(-1_328_483_144)
internal val Res.string.planner_label_code: StringResource by lazy {
      StringResource("string:planner_label_code", "planner_label_code", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19017, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10409, 34),
      ))
    }

@delegate:ResourceContentHash(1_645_654_537)
internal val Res.string.planner_label_duration: StringResource by lazy {
      StringResource("string:planner_label_duration", "planner_label_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19056, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10444, 50),
      ))
    }

@delegate:ResourceContentHash(1_072_858_703)
internal val Res.string.planner_label_hours: StringResource by lazy {
      StringResource("string:planner_label_hours", "planner_label_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19123, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10495, 43),
      ))
    }

@delegate:ResourceContentHash(-9_098_493)
internal val Res.string.planner_label_name: StringResource by lazy {
      StringResource("string:planner_label_name", "planner_label_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19195, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10539, 34),
      ))
    }

@delegate:ResourceContentHash(1_242_631_701)
internal val Res.string.planner_label_subject: StringResource by lazy {
      StringResource("string:planner_label_subject", "planner_label_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19234, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10574, 41),
      ))
    }

@delegate:ResourceContentHash(-1_339_562_244)
internal val Res.string.planner_label_topic: StringResource by lazy {
      StringResource("string:planner_label_topic", "planner_label_topic", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19349, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10665, 35),
      ))
    }

@delegate:ResourceContentHash(-494_534_532)
internal val Res.string.planner_label_topic_unit: StringResource by lazy {
      StringResource("string:planner_label_topic_unit", "planner_label_topic_unit", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19280, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10616, 48),
      ))
    }

@delegate:ResourceContentHash(-570_113_769)
internal val Res.string.planner_msg_no_sessions: StringResource by lazy {
      StringResource("string:planner_msg_no_sessions", "planner_msg_no_sessions", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19393, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10701, 71),
      ))
    }

@delegate:ResourceContentHash(-189_572_439)
internal val Res.string.planner_section_active: StringResource by lazy {
      StringResource("string:planner_section_active", "planner_section_active", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 19545, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10773, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("notes_action_translate", Res.string.notes_action_translate)
  map.put("notes_action_undo", Res.string.notes_action_undo)
  map.put("notes_archive", Res.string.notes_archive)
  map.put("notes_chk_all_completed", Res.string.notes_chk_all_completed)
  map.put("notes_chk_all_completed_emoji", Res.string.notes_chk_all_completed_emoji)
  map.put("notes_chk_progress_format", Res.string.notes_chk_progress_format)
  map.put("notes_chk_tasks_remaining_format", Res.string.notes_chk_tasks_remaining_format)
  map.put("notes_chk_view_all_format", Res.string.notes_chk_view_all_format)
  map.put("notes_details_title", Res.string.notes_details_title)
  map.put("notes_filter_all", Res.string.notes_filter_all)
  map.put("notes_filter_archived", Res.string.notes_filter_archived)
  map.put("notes_filter_pinned", Res.string.notes_filter_pinned)
  map.put("notes_img_fullscreen_desc", Res.string.notes_img_fullscreen_desc)
  map.put("notes_label_attachments", Res.string.notes_label_attachments)
  map.put("notes_label_tags", Res.string.notes_label_tags)
  map.put("notes_msg_create_first", Res.string.notes_msg_create_first)
  map.put("notes_msg_deleted", Res.string.notes_msg_deleted)
  map.put("notes_msg_no_notes", Res.string.notes_msg_no_notes)
  map.put("notes_new_note", Res.string.notes_new_note)
  map.put("notes_pin", Res.string.notes_pin)
  map.put("notes_progress_label", Res.string.notes_progress_label)
  map.put("notes_search_placeholder", Res.string.notes_search_placeholder)
  map.put("notes_stat_tasks", Res.string.notes_stat_tasks)
  map.put("notes_title", Res.string.notes_title)
  map.put("notes_unarchive", Res.string.notes_unarchive)
  map.put("notes_unpin", Res.string.notes_unpin)
  map.put("notes_view_full", Res.string.notes_view_full)
  map.put("onboarding_continue", Res.string.onboarding_continue)
  map.put("onboarding_subtitle", Res.string.onboarding_subtitle)
  map.put("onboarding_title", Res.string.onboarding_title)
  map.put("pdf_arrange_desc", Res.string.pdf_arrange_desc)
  map.put("pdf_arrange_dialog_title", Res.string.pdf_arrange_dialog_title)
  map.put("pdf_arrange_pages_format", Res.string.pdf_arrange_pages_format)
  map.put("pdf_arrange_title", Res.string.pdf_arrange_title)
  map.put("pdf_btn_change_images", Res.string.pdf_btn_change_images)
  map.put("pdf_btn_choose_images", Res.string.pdf_btn_choose_images)
  map.put("pdf_btn_create", Res.string.pdf_btn_create)
  map.put("pdf_btn_create_another", Res.string.pdf_btn_create_another)
  map.put("pdf_btn_edit_settings", Res.string.pdf_btn_edit_settings)
  map.put("pdf_error_generic", Res.string.pdf_error_generic)
  map.put("pdf_error_open", Res.string.pdf_error_open)
  map.put("pdf_error_prefix", Res.string.pdf_error_prefix)
  map.put("pdf_error_select", Res.string.pdf_error_select)
  map.put("pdf_error_share", Res.string.pdf_error_share)
  map.put("pdf_label_max_size", Res.string.pdf_label_max_size)
  map.put("pdf_label_page_size", Res.string.pdf_label_page_size)
  map.put("pdf_label_quality", Res.string.pdf_label_quality)
  map.put("pdf_placeholder_max_size", Res.string.pdf_placeholder_max_size)
  map.put("pdf_size_good", Res.string.pdf_size_good)
  map.put("pdf_size_heavy", Res.string.pdf_size_heavy)
  map.put("pdf_size_large", Res.string.pdf_size_large)
  map.put("pdf_size_medium", Res.string.pdf_size_medium)
  map.put("pdf_size_optimal", Res.string.pdf_size_optimal)
  map.put("pdf_stat_file_size", Res.string.pdf_stat_file_size)
  map.put("pdf_stat_images", Res.string.pdf_stat_images)
  map.put("pdf_stat_pages", Res.string.pdf_stat_pages)
  map.put("pdf_stat_total_size", Res.string.pdf_stat_total_size)
  map.put("pdf_status_converting", Res.string.pdf_status_converting)
  map.put("pdf_step1_subtitle", Res.string.pdf_step1_subtitle)
  map.put("pdf_step1_title", Res.string.pdf_step1_title)
  map.put("pdf_step2_subtitle", Res.string.pdf_step2_subtitle)
  map.put("pdf_step2_title", Res.string.pdf_step2_title)
  map.put("pdf_step3_subtitle", Res.string.pdf_step3_subtitle)
  map.put("pdf_step3_title", Res.string.pdf_step3_title)
  map.put("pdf_step4_subtitle", Res.string.pdf_step4_subtitle)
  map.put("pdf_step4_title", Res.string.pdf_step4_title)
  map.put("pdf_success_message", Res.string.pdf_success_message)
  map.put("pdf_tool_subtitle", Res.string.pdf_tool_subtitle)
  map.put("pdf_tool_title", Res.string.pdf_tool_title)
  map.put("persona_creator_desc", Res.string.persona_creator_desc)
  map.put("persona_creator_name", Res.string.persona_creator_name)
  map.put("persona_developer_desc", Res.string.persona_developer_desc)
  map.put("persona_developer_name", Res.string.persona_developer_name)
  map.put("persona_general_desc", Res.string.persona_general_desc)
  map.put("persona_general_name", Res.string.persona_general_name)
  map.put("persona_professional_desc", Res.string.persona_professional_desc)
  map.put("persona_professional_name", Res.string.persona_professional_name)
  map.put("persona_researcher_desc", Res.string.persona_researcher_desc)
  map.put("persona_researcher_name", Res.string.persona_researcher_name)
  map.put("persona_student_desc", Res.string.persona_student_desc)
  map.put("persona_student_name", Res.string.persona_student_name)
  map.put("planner_badge_completed", Res.string.planner_badge_completed)
  map.put("planner_badge_left", Res.string.planner_badge_left)
  map.put("planner_card_notes", Res.string.planner_card_notes)
  map.put("planner_card_remaining", Res.string.planner_card_remaining)
  map.put("planner_card_spent", Res.string.planner_card_spent)
  map.put("planner_card_target", Res.string.planner_card_target)
  map.put("planner_dialog_add_session_title", Res.string.planner_dialog_add_session_title)
  map.put("planner_dialog_add_subject_title", Res.string.planner_dialog_add_subject_title)
  map.put("planner_dialog_delete_msg", Res.string.planner_dialog_delete_msg)
  map.put("planner_dialog_delete_title", Res.string.planner_dialog_delete_title)
  map.put("planner_label_code", Res.string.planner_label_code)
  map.put("planner_label_duration", Res.string.planner_label_duration)
  map.put("planner_label_hours", Res.string.planner_label_hours)
  map.put("planner_label_name", Res.string.planner_label_name)
  map.put("planner_label_subject", Res.string.planner_label_subject)
  map.put("planner_label_topic", Res.string.planner_label_topic)
  map.put("planner_label_topic_unit", Res.string.planner_label_topic_unit)
  map.put("planner_msg_no_sessions", Res.string.planner_msg_no_sessions)
  map.put("planner_section_active", Res.string.planner_section_active)
}
